export default __webpack_public_path__ + "static/media/finishedIcon.b32a5b5c.svg";